import { Component, OnInit } from "@angular/core";
import { LiveDealerService } from "src/app/services/lobby/live-dealer.service";
import { LobbyNavigator } from "src/app/services/lobby/lobby-navigator.service";
import { KeywordsService } from "src/app/services/lobby/keywords.service";

@Component({
    selector: 'app-live-dealer-favourite-lobby',
    templateUrl: './live-dealer-favourite-lobby.component.html',
    styleUrls: ['./live-dealer-favourite-lobby.component.scss'],
})

export class LiveDealerFavouriteLobbyComponent implements OnInit {

    public favouriteCategories: any[] = [];
    public isAuthenticated: boolean = true;
    public superCategory: string = 'Live Dealer';

    constructor(
        private readonly keywordsService: KeywordsService,
        private readonly liveDealerService: LiveDealerService,
        private readonly lobbyNavigator: LobbyNavigator,
    ) {
    }

    ngOnInit(): void {
        setTimeout(() => this.getfavouriteCategories());
    }

    private async getfavouriteCategories(): Promise<void> {
        this.liveDealerService.favouriteKeywords$.subscribe(
            keywords => {
                this.favouriteCategories = keywords;
            },
            error => console.error("Error getting Fav keywords", error)
        );
    }

    protected launchSubCategoryLobby(data): any {
        this.keywordsService.setLiveDealerFavPath(true);
        this.liveDealerService.setLDFavouriteGameData(data);
        this.lobbyNavigator.liveDealerLoggedIn();
    }

    protected tileActionLoggedOut(data: any) : any {
        console.info("Action not permitted: data: ", data);
        return false;
    }
}